var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soundWave-top",style:({ height: _vm.height })},[_c('div',{staticClass:"record-panel-wrap"},[_c('div',{staticClass:"mainBox"},[_c('div',{ref:"ctrlProcessWave",staticClass:"ctrlProcessWave",staticStyle:{"height":"100%","width":"100%","box-sizing":"border-box","display":"inline-block","vertical-align":"bottom"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }